import React from "react";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "../hooks/useFetch";
import { useSwiper } from "swiper/react";
import arrowFooter from "../css/images/arrow-top-black.svg";
export default function Footer() {
  // На главной Footer живёт внутри Swiper → useSwiper() даёт инстанс.
  // На /legal он используется как обычный подвал, swiper === null —
  // навигационные кнопки тогда ведут на главную.
  const swiper = useSwiper();
  const navigate = useNavigate();

  // Соответствие пунктов меню подвала секциям (нативный скролл, Swiper отключён).
  const SECTION_IDS = ["#about", "#cases", "#work", "#expertise", "#when", "#team", "#partners"];

  function scrollToSlide(num) {
    const target = document.querySelector(SECTION_IDS[num - 1]);
    if (!target) {
      navigate("/");
      return;
    }
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function scrollToBlock(id) {
    const linkBlock = document.querySelector(id);
    if (!linkBlock) {
      navigate("/");
      return;
    }
    const blockTopPosition = linkBlock.getBoundingClientRect().top - 88;

    setTimeout(() => {
      window.scrollBy({
        behavior: "smooth",
        top: blockTopPosition,
      });
    }, 200);
  }

  function scrollToTop() {
    // Стрелка наверх всегда скроллит в начало текущей страницы
    // (и на главной, и на /legal), а не навигирует на главную.
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const contactsFetch = useFetch(`${window.$host}/api/contact?populate=*`);

  if (contactsFetch.loading) return;
  if (contactsFetch.error) return;

  return (
    <footer className="footer bg-dark">
      <div className="container">
        <div className="h-100 footer__box">
          <div className="footer-top">
            <div className="footer-top-content">
              <ul className="footer-mails text-16 text-white">
                {contactsFetch.data.data.Mail.map((item, idx) => (
                  <li
                    key={item.id}
                    className={
                      idx === 0
                        ? "footer-mails__item footer-mails__item-first"
                        : "footer-mails__item"
                    }
                  >
                    <span className={idx !== 0 ? "text-gray" : ""}>
                      {item.Name}
                    </span>
                    <a href={"mailto:" + item.Link}>{item.Link}</a>
                  </li>
                ))}
              </ul>
              <ul className="footer-contacts text-16 text-white footer-menu-desktop">
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToSlide(1)}
                  >
                    Мы
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToSlide(2)}
                  >
                    Кейсы
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToSlide(3)}
                  >
                    Как мы работаем
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToSlide(4)}
                  >
                    Экспертиза
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToSlide(5)}
                  >
                    Когда звать нас
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToSlide(6)}
                  >
                    Команда
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToSlide(7)}
                  >
                    Клиенты
                  </button>
                </li>
              </ul>
              <ul className="footer-contacts text-16 text-white footer-menu-mobile">
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToBlock("#about")}
                  >
                    Мы
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToBlock("#cases")}
                  >
                    Кейсы
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToBlock("#work")}
                  >
                    Как мы работаем
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToBlock("#expertise")}
                  >
                    Экспертиза
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToBlock("#when")}
                  >
                    Когда звать нас
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToBlock("#team")}
                  >
                    Команда
                  </button>
                </li>
                <li>
                  <button
                    className="footer-menu__btn"
                    onClick={() => scrollToBlock("#partners")}
                  >
                    Клиенты
                  </button>
                </li>
              </ul>
              <ul className="footer-contacts text-16">
                <li className="footer-contacts__item">
                  <address className="text-gray">
                    {contactsFetch.data.data.Address}
                  </address>
                </li>
                <li className="footer-contacts__item">
                  <a
                    className="text-white footer-contacts__link"
                    href={
                      "tel:" +
                      contactsFetch.data.data.Phone.replace(/[^0-9+]/g, "")
                    }
                  >
                    {contactsFetch.data.data.Phone}
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-top__box">
              <button className="to-top" onClick={scrollToTop}>
                <img src={arrowFooter} alt="#" />
              </button>
              <div className="footer-top__block-bottom">
                <button
                  onClick={scrollToTop}
                  className="footer-top__small-logo"
                >
                  <img
                    src={window.$host + contactsFetch.data.data.LogoSmall.url}
                    alt={contactsFetch.data.data.LogoSmall.alternativeText}
                  ></img>
                </button>
                <ul className="footer-socials text-16 text-white">
                  {contactsFetch.data.data.Socials.map((item) => (
                    <li key={item.id} className="footer-socials__item">
                      <a
                        href={item.Link}
                        className="footer-socials__link"
                        target="_blank"
                      >
                        {item.Name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <span className="footer-copyright">
              Copyright © 2026 ООО «ДЕВЯТЬ АЙТИ»
            </span>
            <Link to="/legal" className="footer-legal-link">
              Юридическая информация
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
